import React from 'react';

import { di } from 'react-magnetic-di';

import { isSafeUrl } from '@atlaskit/adf-schema/is-safe-url';
import Link from '@atlaskit/link/link';
import { Text } from '@atlaskit/primitives/compiled';

import { asFormTextField } from '../../../../../../../../common/types/form/form-fields/utils';
import type { FormFieldComponentRendererProps } from '../../../../../../../../common/types/renderers';
import { useFormField } from '../../../../../../../../controllers/form-renderer-store';

export const ViewUrlInput = ({ fieldId }: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormField);
	const formField = useFormField({ fieldId });
	const formTextField = asFormTextField(formField);

	if (formTextField === undefined) {
		return <></>;
	}

	return (
		<Text testId="field-input-url-view">
			{formTextField.value !== undefined && isSafeUrl(formTextField.value.text) ? (
				<Link href={formTextField.value.text} target="_blank">
					{formTextField.value.text}
				</Link>
			) : (
				formTextField.value?.text
			)}
		</Text>
	);
};
